import JobsCourses from "@components/jobs-courses";
import Intro from "@components/pages/jobs/intro";
import IntroducingScholarsWays from "@components/pages/jobs/introducing-scholars-ways";
import JobsContainer from "@components/pages/jobs/jobs-container";
import SEOHEAD from "@components/SEOHEAD";
import FAQ from "@components/ui/details/FAQ";
import gate from "gate";
import { GetServerSideProps } from "next";
import React, { FC } from "react";
import { dehydrate, QueryClient, useMutation, useQuery } from "react-query";

import { sortArrayByOrder } from "../../src/utils";

const faq = [
  {
    id: 1,
    title: "هدف از ایجاد صفحه فرصت‌های شغلی چیست؟",
    description:
      "یکی از دغدغه‌‌های مهم دانش‌پذیران بعد از گذراندن دوره‌ها، این است که چگونه استخدام شوند؟ از طرف دیگر تقریباً همه صاحبان کسب و کارها برای رشد کسب و کارشان به دنبال نیروی متخصص می‌گردند. هدف ما از راه‌اندازی صفحه فرصت‌های شغلی ایجاد پل ارتباطی بین دانش‌پذیران و صاحبان کسب و کارها است.",
  },
  {
    id: 2,
    title: "دانش‌پذیران دادبانان چگونه به بازار کارمعرفی می‌شوند؟",
    description:
      "دانش‌پذیرانی که در دوره‌های موسسه دادبانان شرکت کرده باشند پس از ارزیابی و تایید توسط اساتید مجموعه، به صفحه فرصت‌های شغلی هدایت می‌شوند. دانشپذیرانی که از طریق سایت دادبانان ارسال رزومه نمایند در اولویت استخدام شرکت‌ها و سازمان‌ها قرار خواهند گرفت.",
  },
  {
    id: 3,
    title: "آیا آگهی‌های استخدام در سایت دادبانان به روز هستند؟",
    description:
      "بله؛ در صفحه فرصت‌های شغلی شما می‌توانید جدیدترین و به‌روزترین آگهی‌های استخدام را مشاهده کنید.",
  },
  {
    id: 4,
    title: "چه منابعی برای آموزش مهارت‌های جدید و افزایش توانایی‌ها وجود دارد؟",
    description: `
    <p>کسانی که به دنبال کار حقوقی هستند، دلایل متعددی برای شرکت در دوره‌های آموزشی موسسه دادبانان دارند. این دلایل می‌توانند شامل موارد زیر باشند:</p>
    <ul class = "list-disc mr-8">
    <li>آموزش‌های تخصصی و به‌روز</li>
    <li>مدرسان مجرب</li>
    <li>شبکه‌سازی حرفه‌ای</li>
    <li>کارگاه‌ها و دوره‌های عملی</li>
    <li>اعتبار و شهرت</li>
    <li>مشاوره شغلی</li>
    </ul>
    <p>
    به طور کلی، شرکت در دوره‌های آموزشی موسسه دادبانان می‌تواند پایه‌های قوی‌تری برای شروع یک حرفه موفق در حوزه حقوق فراهم کند و مهارت‌ها و دانش لازم برای پیشرفت در این حوزه را به افراد بدهد.
    </p>
    `,
  },
  {
    id: 5,
    title: "چگونه یک رزومه مناسب بنویسیم؟",
    description: `
    <p>تنظیم یک رزومه حقوقی نیازمند دقت و توجه به جزئیات است تا مهارت‌ها، تجربیات و دستاوردهای شما به بهترین شکل نمایش داده شوند. در زیر مراحل و نکات مهم برای تنظیم یک رزومه حقوقی آورده شده است:</p>
    <p>1. اطلاعات شخصی</p>
    <p>نام و نام خانوادگی: در بالای رزومه و به صورت برجسته.</p>
    <p>اطلاعات تماس: شامل شماره تلفن، آدرس ایمیل حرفه‌ای و در صورت لزوم آدرس پستی.</p>
    <p>2. خلاصه‌ی حرفه‌ای</p>
    <p>یک خلاصه کوتاه (حدود 2-3 جمله) که مهارت‌ها، تجربیات و اهداف شغلی شما را به طور خلاصه بیان می‌کند.</p>
    <p>3. تحصیلات</p>
    <p>نام دانشگاه و دانشکده: ذکر نام دانشگاه، دانشکده حقوق و محل آن.</p>
    <p>مدرک تحصیلی: عنوان مدرک (مثلاً کارشناسی ارشد حقوق).</p>
    <p>تاریخ فارغ‌التحصیلی: ماه و سال فارغ‌التحصیلی.</p>
    <p>معدل و افتخارات: در صورت داشتن معدل بالا یا افتخارات علمی.</p>
    <p>4. تجربیات حرفه‌ای</p>
    <p>عنوان شغل: عنوان شغل شما (مثلاً وکیل، مشاور حقوقی).</p>
    <p>نام شرکت/سازمان: نام محل کار و محل آن.</p>
    <p>تاریخ استخدام: ماه و سال شروع و پایان کار.</p>
    <p>توضیحات شغلی: شرح وظایف و مسئولیت‌ها و دستاوردهای مهم.</p>
    `,
  },
  {
    id: 6,
    title: "نحوه ارسال رزومه در سایت دادبانان چگونه است؟",
    description: `<p>ابتدا وارد سایت دادبانان شده و بر روی منوی فرصت‌های شغلی کلیک نمایید. در این صفحه به روزترین آگهی‌های استخدامی در حوزه حقوقی برای فارغ التحصیلان موسسه دادبانان نمایش داده خواهد شد. با کلیک بر روی لینک جزئیات بیشتر وارد صفحه آگهی کارفرما شده و در صورت تمایل دکمه ارسال رزومه را کلیک نمایید. رزومه شما از طریق سایت جاب ویژن برای کارفرما ارسال می‌شود؛ همچنین عنوان دوره‌هایی که در دادبانان شرکت نموده‌اید را به تفکیک تصریح نمائید.</p>
    <p class = "mt-4">نکته: ارسال رزومه از طریق سایت دادبانان فقط برای فارغ التحصیلان موسسه دادبانان انجام می‌شود و افرادی که از طریق موسسه دادبانان رزومه ارسال نمایند در اولویت استخدام قرار می‌گیرند.</p>`,
  },
];
export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const queryClient = new QueryClient();
  try {
    await queryClient.fetchQuery([`recommended-entity-for-job`], () =>
      gate.recommendedEntityForJob()
    );
  } catch (error: any) {
    ctx.res.statusCode = error?.response?.status;
    return {
      notFound: true,
    };
  }
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

const Jobs: FC = () => {
  const { data } = useQuery(
    [`recommended-entity-for-job`],
    () => gate.recommendedEntityForJob(),
    {
      select: (data: any) => data?.data.output,
      refetchOnWindowFocus: false,
      onError: (error) => console.log(error),
    }
  );

  return (
    <>
      <SEOHEAD
        {...{
          canonical: `https://dadbanan.com/jobs`,
          title:
            "آگهی استخدام؛ جدیدترین فرصت‌های شغلی حقوقی در معتبرترین شرکت‌ها | دادبانان",
          keyword: ["فرصت های شغلی", "آگهی استخدام"],
          seoDescription:
            "دادبانان بستری برای پیدا کردن شغلی مناسب برای وکلا، کارآموزان، مشاوران حقوقی و.. از میان هزاران آگهی استخدام شرکت‌های معتبر است.",
        }}
      />
      <Intro />
      <section className="px-[4%] py-8 lg:px-[12%]">
        <JobsContainer />
      </section>

      <IntroducingScholarsWays />
      <article className="px-[4%] py-8 lg:px-[12%]">
        <JobsCourses data={data} title={"دوره ها و بسته های مرتبط با مشاغل"} />
      </article>
      {faq.length !== 0 && (
        <div className="mt-4 flex w-full gap-x-2 bg-gray-150 px-[10%] py-4 md:mt-10 lg:mt-8 lg:py-8 lg:px-[13%]">
          <FAQ
            frequentlyAskedQuestions={sortArrayByOrder(faq, "order") as any}
            isHtml={true}
          />
        </div>
      )}
    </>
  );
};

export default Jobs;
